import axios, { AxiosResponse } from 'axios';

import { setupAuthInterceptor } from '../core/auth-interceptor';
import { REQUEST_TIMEOUT_MS } from '../core/constants/request-constants';

import type { CheckEmailResponse, SignupPayload, SignupResponse } from './types/user-auth-api-service-types';

const _userAuthApiClient = axios.create({
  baseURL: import.meta.env.VITE_APP_API_BASE_URL + '/auth',
  timeout: REQUEST_TIMEOUT_MS,
  headers: {
    'x-api-key': import.meta.env.VITE_APP_COGNITO_AUTH_API_KEY,
  },
});

setupAuthInterceptor(_userAuthApiClient);

export const UserAuthApiService = {
  signup: (payload: SignupPayload): Promise<AxiosResponse<SignupResponse>> => {
    return _userAuthApiClient.post('/signup', payload);
  },

  forgotPassword: (email: string) => {
    return _userAuthApiClient.post('/forgotPassword', {
      email,
    });
  },

  confirmByCode: (data: { email: string; confirmationCode: string }) => {
    return _userAuthApiClient.post('/confirm', data);
  },

  sendEmail: (data: any) => {
    return _userAuthApiClient.post('/resend', data);
  },

  checkEmail: (email: string): Promise<AxiosResponse<CheckEmailResponse>> => {
    return _userAuthApiClient.post('/check-email', { email });
  },
};
